(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pott-header"]) return;
  try {
    
  import('@shopify/events').then(({ StandardEvents }) => {
    document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
      event.promise
        ?.then(({ cart, detail }) => {
          const itemCount = cart?.totalQuantity ?? detail?.itemCount;
          if (!Number.isInteger(itemCount) || itemCount < 0) return;

          for (const link of document.querySelectorAll('.pott-header__cart')) {
            const badge = link.querySelector('[data-pott-cart-count]');
            if (badge) {
              badge.textContent = String(itemCount);
              badge.hidden = itemCount === 0;
              badge.style.display = itemCount === 0 ? 'none' : '';
            }
            link.setAttribute('aria-label', `${link.dataset.cartLabel} (${itemCount})`);
          }
        })
        .catch(() => {});
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ruhr-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pott-collection')) {
    customElements.define('pott-collection', class extends HTMLElement {
      connectedCallback() {
        if (this.pcInitialized) return;
        this.pcInitialized = true;
        this.disclosure = this.querySelector('.pc-lookbook__disclosure');
        this.groups = Array.from(this.querySelectorAll('[data-pc-group]'));
        this.filters = Array.from(this.querySelectorAll('[data-pc-filter]'));
        this.results = this.querySelector('[data-pc-results]');
        this.querySelector('[data-pc-filters]')?.removeAttribute('hidden');
        this.pcClick = (event) => {
          const filter = event.target.closest('[data-pc-filter]');
          const categoryLink = event.target.closest('[data-pc-category-link]');
          const openLink = event.target.closest('[data-pc-open]');
          if (filter && this.contains(filter)) this.applyFilter(filter.dataset.pcFilter);
          if (categoryLink && this.contains(categoryLink)) {
            event.preventDefault();
            this.disclosure.open = true;
            this.applyFilter(categoryLink.dataset.pcCategoryLink, false);
            const target = this.querySelector(categoryLink.getAttribute('href'));
            target?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
            target?.querySelector('h3')?.focus({ preventScroll: true });
          }
          if (openLink && this.contains(openLink)) {
            this.disclosure.open = true;
            this.applyFilter('all', false);
          }
        };
        this.pcBlockSelect = (event) => {
          if (!this.contains(event.target)) return;
          const group = event.target.closest('[data-pc-group]');
          if (group) {
            this.disclosure.open = true;
            this.applyFilter('all', false);
          }
        };
        this.addEventListener('click', this.pcClick);
        document.addEventListener('shopify:block:select', this.pcBlockSelect);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.pcClick);
        document.removeEventListener('shopify:block:select', this.pcBlockSelect);
        this.pcInitialized = false;
      }
      applyFilter(category, animate = true) {
        const update = () => {
          let count = 0;
          this.groups.forEach((group) => {
            group.hidden = category !== 'all' && group.dataset.pcGroup !== category;
            if (!group.hidden) count += group.querySelectorAll('[data-pc-design]').length;
          });
          this.filters.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.pcFilter === category)));
          if (this.results) this.results.textContent = this.results.dataset.pcCountTemplate.replace('__count__', String(count));
        };
        if (animate && document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(update);
        else update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
